interface PhoneWithBoxesConnectedSVGProps {
  color: string;
  style: React.CSSProperties;
}

const PhoneWithBoxesConnectedSVG = ({
  color,
  style,
}: PhoneWithBoxesConnectedSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="67"
    height="49"
    viewBox="0 0 67 49"
    fill="none"
  >
    <g clipPath="url(#clip0_564_17681)">
      <path
        d="M24.4509 22.6766L35.0435 16.2178L45.6361 22.6766"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M24.4509 22.6766V35.5944L35.0435 42.0404L45.6361 35.5944V22.6766"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M35.0437 29.1355V37.7131"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M45.6362 22.6766L57.5301 15.4216"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.53 15.4216L60.8136 13.4057"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.6572 3.96777V10.2597L60.8137 13.4057L65.9701 10.2597V3.96777L60.8137 0.821808L55.6572 3.96777Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M15.2814 30.1242L8.26428 34.3488L1.33228 30.1242"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M1.33228 30.1242V38.5734L8.26428 42.8108L15.1963 38.5734"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M19.1243 32.4099V44.6085C19.1243 46.6373 20.6809 48.2938 22.6146 48.2938H47.5333C49.4184 48.2938 50.9385 46.6758 50.9385 44.6984V19.4279"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M50.9506 14.6127V4.55845C50.9506 2.59382 49.4426 0.988739 47.5698 0.988739H22.4929C20.6322 0.988739 19.1121 2.58098 19.1121 4.55845V27.0296"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M29.1453 0.988739V2.73507C29.1453 3.80085 29.9601 4.66117 30.9695 4.66117H39.1055C40.1149 4.66117 40.9297 3.80085 40.9297 2.73507V0.988739"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M55.6572 3.96777L60.8137 6.98533"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M24.4509 22.6766L35.0435 29.1355"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M1.33228 30.1242L8.26428 25.8996L24.4511 35.5943"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_564_17681">
        <rect
          width="66"
          height="49"
          fill={color}
          transform="translate(0.651123)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default PhoneWithBoxesConnectedSVG;
